import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { selectUser } from '../../containers/App/selectors';

type V2AccountNavProps = {
  active: 'profile' | 'settings';
};

const V2AccountNav: React.FC<V2AccountNavProps> = ({ active }) => {
  const user = useSelector(selectUser);

  return (
    <nav className="v2-account-nav" aria-label="Разделы аккаунта">
      <Link
        to="/profile"
        className={classNames(active === 'profile' && 'active')}
        aria-current={active === 'profile' ? 'page' : undefined}
      >
        Мой аккаунт
      </Link>
      <Link
        to="/settings"
        className={classNames(active === 'settings' && 'active')}
        aria-current={active === 'settings' ? 'page' : undefined}
      >
        Настройки
      </Link>
      {user?.isAdmin ? (
        <Link to="/admin" className="v2-account-nav__admin">
          Панель админа
        </Link>
      ) : null}
    </nav>
  );
};

export default V2AccountNav;
